<template>
  <div
    :class="[bem.b(), prepareClassNames()]"
    :style="{
      ...prepareStyles(),
    }"
  >
    <el-page-header v-if="isShowBack" @back="goBack">
      <template #content> </template>
    </el-page-header>
    <EpButtons :list="buttons" />
    <EpAttachment
      v-if="props.isShowAttachmentButton"
      :model-value="props.fileList"
      is-show-open-dialog-button
      v-bind="props.attachmentProps"
    />
  </div>
</template>
<script setup lang="ts">
import { createNameSpace } from '@el-plus/utils/bem'
import { headerProps, headerEmits } from './header'
import { prepareClassNames, prepareStyles } from '@el-plus/utils/props'
import { useHeader, useButtons } from './use-header'
import { ElPageHeader } from 'element-plus'
import EpButtons from '@el-plus/components/buttons'
import EpAttachment from '@el-plus/components/attachment'
defineOptions({
  name: 'EpHeader',
  inheritAttrs: false,
})
const bem = createNameSpace('header')
const props = defineProps(headerProps)
const emit = defineEmits(headerEmits)
const { isShowBack, goBack } = useHeader(props, emit)
const { buttons } = useButtons(props, emit)
</script>
